export const svgPropsMapper =  {
    props:{
        kcpGroupId: null,
        sprKcpGroupId: null,
        sprKcpGroupName: null,
        uslName: null,
        foName: null,
        regionId: null,
        regionName: null,
        regionNameGenitive: null,
    },
    data() {
        return {
            loading: false
        }
    },
    computed: {
        dataName() {
            return Object.keys(this.$data).find(el => el.search('get') !== -1);
        }
    },
    methods: {
        mapServerData(data = this.$data[this.dataName]){
            for (const [key,value] of Object.entries(data)){
                if (value === 'string')
                {
                    const result = key.match(/[nN]ame/gm)?.length > 0 ? value ?? (this.$props[key] ?? 'x') : value ?? 'x';
                    this.$data[this.dataName][key] = result === 'string' ? (this.$props[key] ?? 'x') : result;
                }
                else
                    this.$data[this.dataName][key] = this.$scripts.TableJs.checkValueWithNullAndReturnND(value, 2, '',true,'н.д.','',(v) => v)
            }
        },
        changeDefaultValues() {
                this.$data[this.dataName].regionName = this.$props.regionName;
                this.$data[this.dataName].sprRegionName = this.$props.regionName;
                this.$data[this.dataName].sprKcpGroupId = '';
                this.$data[this.dataName].foName = this.$props.foName;
                this.$data[this.dataName].regionNameGenitive = this.$props.regionName;

                this.$data[this.dataName].uslName = this.$props.uslName;
                this.$data[this.dataName].sprKcpGroupSprUslName = this.$props.uslName;
                this.$data[this.dataName].sprKcpGroupName = this.$props.sprKcpGroupName;
        }
    },
}